import { Field, Input, TextArea } from '@unbounded/unbounded-components'
import React, { useCallback, useEffect, useState } from 'react'
import Paths from '~routes/paths'
import * as Styled from './ContactForm.styles'

interface Props {
  onSubmit: (email: string, name: string, message: string) => void
  isLoading?: boolean
  error?: string
  isSuccess?: boolean
}

const ContactForm: React.FC<Props> = ({ onSubmit, isLoading, isSuccess, error }) => {
  const [name, setName] = useState<string>('')
  const [email, setEmail] = useState<string>('')
  const [message, setMessage] = useState<string>('')

  useEffect(() => {
    if (isSuccess) {
      setName('')
      setEmail('')
      setMessage('')
    }
  }, [isSuccess])

  const handleSubmit = useCallback(
    (event: React.FormEvent) => {
      event.preventDefault()
      onSubmit(email, name, message)
    },
    [name, email, message, onSubmit]
  )

  return (
    <Styled.Form onSubmit={handleSubmit}>
      <Field label="Your Name">
        <Input value={name} onValueChange={setName} placeholder="John Doe" autoComplete="name" required />
      </Field>
      <Field label="Email address">
        <Input type="email" value={email} onValueChange={setEmail} placeholder="name@mail.com" required />
      </Field>
      <Field label="Message">
        <TextArea rows={5} value={message} onValueChange={setMessage} required />
      </Field>
      <Field>
        By clicking submit you agree to our <Styled.Link to={Paths.termsOfUse}>User Agreement</Styled.Link> and{' '}
        <Styled.Link to={Paths.privacyPolicy}>Privacy Policy</Styled.Link>.
      </Field>
      <Styled.Actions>
        <Styled.Button type="submit" isLoading={isLoading} isSuccess={isSuccess}>
          Submit
        </Styled.Button>
        {error && <Styled.Error>{error}</Styled.Error>}
      </Styled.Actions>
    </Styled.Form>
  )
}

export default ContactForm
